import { graphql, useStaticQuery } from 'gatsby';
import React from "react";
import { useIntl, FormattedMessage } from 'react-intl';

import {
  Banner,
  Description,
  Title,
  Text,
} from './styles';

  interface Props {
    brand?: string;
    type?: string;
    state?: string;
  }

const AccessoryPromotions = ({
  state,
  brand,
  type,
}: Props) => {
  const { locale } = useIntl();
  const { accessoryPromotionsEN, accessoryPromotionsFR } = useStaticQuery(graphql`
    query {
      ...AccessoryPromotionsQuery
    }
  `);
  const accessoryPromotions = locale === 'en' ? accessoryPromotionsEN?.nodes : accessoryPromotionsFR?.nodes;

  if (!accessoryPromotions || accessoryPromotions?.length === 0) return null;

  // Get all active promotions
  const getActivePromotions = accessoryPromotions.filter((item) => item.isActive);

  // Pair promotions with matching accessory criteria
  // eslint-disable-next-line max-len
  const getMatchingPromotions = getActivePromotions.map((item) => item.promotionCriteria?.find((promo) => (
    (promo?.brand === brand && promo?.accessoryType === null)
      || (promo?.brand === null && promo?.accessoryType?.value === type)
      || (promo?.brand === brand && promo?.accessoryType?.value === type)
  )));

  // Remove any undefined items from the intitial filtering on promotions
  const promotions = getMatchingPromotions?.filter((item) => !!item);

  if (promotions?.length) {
    return (
      <>
        {state === 'banner' && (
          <Banner>
            {promotions.length > 1 ? (
              <FormattedMessage id="LimitedTimeOffers" />
            ) : (
              promotions[0]?.accessory_promotion[0]?.displayTag
            )}
          </Banner>
        )}
        {state === 'text' && (
          <Description>
            {promotions.length > 1 ? (
              <>
                <Title>
                  <FormattedMessage id="LimitedTimeOffers" />
                </Title>
                {promotions.map((offer) => (
                  <Text key={offer?.accessory_promotion[0]?.displayName}>
                    {offer?.accessory_promotion[0]?.displayName}
                  </Text>
                ))}
              </>
            ) : (
              <>
                <Title>
                  {promotions[0]?.accessory_promotion[0]?.displayTag}
                </Title>
                <Text>
                  {promotions[0]?.accessory_promotion[0]?.displayName}
                </Text>
              </>
            )}
          </Description>
        )}
      </>
    );
  }
  return null;
};

export default AccessoryPromotions;
